import type { PropsWithChildren, ReactNode } from 'react'
import { type SVGIllustrationProps } from '@dhl-ui/illustrations'
import { Body1, Grid, H5 } from '@dhl-ui/components'

type Props = PropsWithChildren<{
  title: ReactNode
  Image: React.FC<SVGIllustrationProps>
  dataTest?: string
}>

export const NotAvailablePage = ({ title, children, Image, dataTest = 'route-not-found' }: Props) => (
  <Grid
    container
    data-testid={dataTest}
    sx={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
    }}
  >
    <Grid sx={{ pb: 4 }}>
      <Image fontSize="large" width={250} height={180} />
    </Grid>
    <Grid
      size={{ md: 6, xl: 5 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <H5>{title}</H5>
      <Body1 component="div">{children}</Body1>
    </Grid>
  </Grid>
)
